import { render, staticRenderFns } from "./hamburger-button.vue?vue&type=template&id=2a79fcd3&"
import script from "./hamburger-button.vue?vue&type=script&lang=js&"
export * from "./hamburger-button.vue?vue&type=script&lang=js&"
import style0 from "./hamburger-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a79fcd3')) {
      api.createRecord('2a79fcd3', component.options)
    } else {
      api.reload('2a79fcd3', component.options)
    }
    module.hot.accept("./hamburger-button.vue?vue&type=template&id=2a79fcd3&", function () {
      api.rerender('2a79fcd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/hamburger-button.vue"
export default component.exports